import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { executeAwaitableHandlerChain, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { CatalogPage } from "@insite/client-framework/Services/CategoryService";
import * as ProductServiceV2 from "@insite/client-framework/Services/ProductServiceV2";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { chain, DispatchLoadProducts, ParseQueryParameter, SetExpandTokens } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { isLoadMore } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { ProductFiltersExtended } from "@WhiteCap/Store/Reducer/WhiteCapReducer/ProductListIsStockAvailableReducer";
import qs from "qs";

interface Parameter {
    queryString?: string;
    path: string;
    isSearch: boolean;
}

export interface DisplayProductsResult {
    products?: ProductModel[];
    productInfosByProductId: SafeDictionary<ProductInfo>;
    productFilters: ProductFilters;
    isFiltered: boolean;
    unfilteredApiParameter?: ProductServiceV2.GetProductCollectionApiV2Parameter;
    filteredApiParameter?: ProductServiceV2.GetProductCollectionApiV2Parameter;
    catalogPage?: CatalogPage;
}

interface Props {
    apiParameter: ProductServiceV2.GetProductCollectionApiV2Parameter;
    idByPath?: SafeDictionary<string>;
    result: DisplayProductsResult;
    pricingLoaded?: true;
    expandTokens?: ProductServiceV2.ProductExpandTokens;
}

type HandlerType = Handler<Parameter, Props>;

export const AddToExpandTokens: HandlerType = props => {
    if (props.expandTokens) {
        props.expandTokens.push("properties");
    }
};

export const DispatchLoadProductsWithoutValidation: HandlerType = async props => {
    props.result.products = await executeAwaitableHandlerChain(
        loadProducts,
        {
            ...props.apiParameter,
            isLoadMore: isLoadMore(props.getState()) && !!props.apiParameter.page && props.apiParameter.page > 1,
        },
        props,
    );
};

export const ParseQueryStringForIsInStockedAtbranch: HandlerType = props => {
    const { queryString = "" } = props.parameter;
    const parsedQuery = qs.parse(queryString.startsWith("?") ? queryString.substr(1) : queryString) as any;
    
    (props.result.productFilters as ProductFiltersExtended).isInStockAtBranch = parsedQuery.isInStockAtBranch
};

export const DispatchSetFilterQueryStockedBranchExtended: HandlerType = props => {
    props.dispatch({
        type: "Custom/ProductList/IsStockAvailable/SetIsInStockAtBranch",
        data: props.result.productFilters,
    });
};

addToChainAfter(chain, SetExpandTokens, AddToExpandTokens);
replaceInChain(chain, DispatchLoadProducts, DispatchLoadProductsWithoutValidation);
addToChainAfter(chain, ParseQueryParameter, ParseQueryStringForIsInStockedAtbranch);
addToChainAfter(chain, ParseQueryStringForIsInStockedAtbranch, DispatchSetFilterQueryStockedBranchExtended);